import { getMessages } from '../../../../../../store/constants';

export const CLASS_ESSENTIAL_UPGRADE_BUTTON= 'essential-upgrade-button';

export const ESSENTIAL_UPGRADE_BUTTON_LABEl = getMessages().getText('essential.upgrade');
